<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Data Access Authorization</span>

  <ng-container dialog-content>
    <div class="privacy-warning">
      <p><strong>Access to personally identifiable information (PII) within this platform is restricted and must be based on a legitimate and specific purpose consistent with applicable privacy laws and the platform's Privacy Policy.</strong></p>

      <p>Licensees must certify that any request to view PII:</p>
      <ul>
        <li>Is directly related to their responsibilities as license holders</li>
        <li>Is for a lawful, documented, and proportionate purpose</li>
        <li>Is submitted in good faith and will be handled in accordance with applicable data protection obligations</li>
      </ul>

      <p><em>All access requests are logged and subject to periodic audit by the platform operator. Misuse or unauthorized access may result in suspension of access privileges and regulatory reporting.</em></p>

      <p>Please specify the reason for this access and provide additional details if necessary.</p>
    </div>

    <form>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Access Reason</mat-label>
        <mat-select [formControl]="reasonControl" data-testid="access-reason-select">
          <mat-option data-testid="access-reason-option" *ngFor="let reason of availableReasons" [value]="reason.Value">
            {{reason.Name}}
          </mat-option>
        </mat-select>
        <mat-error data-testid="access-reason-error-message"
                   *ngIf="(reasonControl.dirty || reasonControl.touched) && reasonControl.errors">
          Please select a reason for accessing this data
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Additional Details (Optional)</mat-label>
        <textarea
          matInput
          [formControl]="additionalDetailsControl"
          data-testid="additional-details-textarea"
          placeholder="Provide any additional context or justification for this access request..."
          rows="4"
          maxlength="4000">
        </textarea>
        <mat-hint align="end">{{additionalDetailsControl.value?.length || 0}}/4000</mat-hint>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button class="btn-success" [disabled]="!canContinue()" data-testid="authorize-access-button" (click)="submit()">Continue</button>
  </ng-container>
</app-dialog-base>
